import {
  ACTIVITY_CENTER_FEATURE_TAB_NAMES,
  ACTIVITY_CENTER_TAB_NAMES
} from '@/constants/activityCenter'

const JOB_TYPE_TO_FEATURE = Object.freeze({
  USER_EXPORT: ACTIVITY_CENTER_FEATURE_TAB_NAMES.ON_DEMAND_EXPORTS,
  COMPONENT_VALIDATION: ACTIVITY_CENTER_FEATURE_TAB_NAMES.BOM_VALIDATIONS,
  TEST_CASE_VALIDATION: ACTIVITY_CENTER_FEATURE_TAB_NAMES.TEST_CASE_VALIDATIONS,
  UNUSABLE_CHOICES_VALIDATION: ACTIVITY_CENTER_FEATURE_TAB_NAMES.TEST_CASE_VALIDATIONS,
  INSPECTION: ACTIVITY_CENTER_FEATURE_TAB_NAMES.INSPECTIONS,
  CONFIGURATION_LIST_EXPORT: ACTIVITY_CENTER_FEATURE_TAB_NAMES.EXPORTS,
  CALCULATE_COMBINATIONS: ACTIVITY_CENTER_FEATURE_TAB_NAMES.SAVED_TABLES,
  AMBIGUOUS_COMBINATION: ACTIVITY_CENTER_FEATURE_TAB_NAMES.AMBIGUOUS_COMBINATIONS,
  SCHEDULED_COLLECTION: ACTIVITY_CENTER_FEATURE_TAB_NAMES.SCHEDULES
})

const JOB_TYPE_TO_SERVICE = Object.freeze({
  USER_EXPORT: 'pmm',
  COMPONENT_VALIDATION: 'pmv',
  TEST_CASE_VALIDATION: 'pmv',
  UNUSABLE_CHOICES_VALIDATION: 'pmv',
  INSPECTION: 'pmv',
  CONFIGURATION_LIST_EXPORT: 'pac',
  CALCULATE_COMBINATIONS: 'vm',
  AMBIGUOUS_COMBINATION: 'vm',
  SCHEDULED_COLLECTION: 'vm'
})

const RESULT_TO_STATUS = Object.freeze({
  FAILED: ACTIVITY_CENTER_TAB_NAMES.FAILED,
  FAILURE: ACTIVITY_CENTER_TAB_NAMES.FAILED,
  ERROR: ACTIVITY_CENTER_TAB_NAMES.FAILED,
  IN_PROGRESS: ACTIVITY_CENTER_TAB_NAMES.IN_PROGRESS,
  RUNNING: ACTIVITY_CENTER_TAB_NAMES.IN_PROGRESS,
  STARTED: ACTIVITY_CENTER_TAB_NAMES.IN_PROGRESS,
  COMPLETED: ACTIVITY_CENTER_TAB_NAMES.COMPLETED,
  SUCCESS: ACTIVITY_CENTER_TAB_NAMES.COMPLETED,
  SUCCEEDED: ACTIVITY_CENTER_TAB_NAMES.COMPLETED
})

const getActivityStatus = ({ type, severity, data = {} }) => {
  const normalizedType = type?.toUpperCase()

  if (normalizedType?.endsWith('_FAILED')) {
    return ACTIVITY_CENTER_TAB_NAMES.FAILED
  }

  if (normalizedType?.endsWith('_COMPLETED')) {
    return ACTIVITY_CENTER_TAB_NAMES.COMPLETED
  }

  if (normalizedType?.endsWith('_STARTED')
        || normalizedType?.endsWith('_IN_PROGRESS')) {
    return ACTIVITY_CENTER_TAB_NAMES.IN_PROGRESS
  }

  const statusFromResult = RESULT_TO_STATUS[data.result?.toUpperCase()]

  if (statusFromResult) return statusFromResult

  if (severity?.toUpperCase() === 'ERROR') {
    return ACTIVITY_CENTER_TAB_NAMES.FAILED
  }

  return null
}

const getActivityFeature = ({ data = {} }) => JOB_TYPE_TO_FEATURE[
  data.jobType?.toUpperCase()
] || null

const getActivityServiceName = ({ data = {} }) => JOB_TYPE_TO_SERVICE[
  data.jobType?.toUpperCase()
] || null

export const mapNotificationToActivity = notification => {
  if (!notification?.eventId) {
    throw new Error('Cannot create an activity without an eventId')
  }

  const status = getActivityStatus(notification)
  const feature = getActivityFeature(notification)

  if (!status) {
    throw new Error(`Unsupported notification type: ${ notification.type }`)
  }

  if (!feature) {
    throw new Error(`Unsupported notification job type: ${ notification.data?.jobType }`)
  }

  const actions = Array.isArray(notification.actions)
    ? notification.actions
    : []

  return {
    id: notification.eventId,
    eventId: notification.eventId,
    correlationId: notification.data?.correlationId || null,
    feature,
    status,
    title: notification.title || '',
    createdAt: notification.occurredAt,
    message: notification.body || '',
    canRetry: notification.data?.retryable === true,
    progress: Number.isFinite(notification.data?.progress)
      ? notification.data.progress
      : null,
    actions,
    source: notification.source || null,
    serviceName: getActivityServiceName(notification),
    data: notification.data || {},
    read: notification.read === true
  }
}

export default mapNotificationToActivity
